// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__9ZuJn","pages":"Pagination_pages__GOk-g","page":"Pagination_page__lNLf8","currentPage":"Pagination_currentPage__Le3Q9"};